jQuery(document).ready(function($){

    $('.is-accordion-submenu-parent > a').click(function(){
        if ($(this).attr('href') != '#') {
            $(this).unbind('click');
        }
    });

    $('.product-categories .cat-parent > .inner > a').click(function(event) {
        event.preventDefault();
        var $parent = $(this).closest('.cat-parent');
        $parent.find('.children').slideToggle('fast');
        $parent.toggleClass('active');
        $(this).unbind('click');
    });

});
